import { classNames } from "@components/library/utils/classNames";
import Link from "next/link";
import { useRouter } from "next/router";
import { ReactElement } from "react";

export const PolicyLinks = () => (
  <aside className="flex flex-col gap-24">
    {/* TODO: website terms of use */}
    <SideLink href={"/policies/privacy-policy"}>Privacy Policy</SideLink>
    <SideLink href={"/policies/subscription-terms"}>
      Subscription Terms of Use
    </SideLink>
    <SideLink href={"/policies/data-processing"}>
      Data Processing Addendum
    </SideLink>
  </aside>
);
const SideLink = ({
  href,
  children,
}: {
  href: string;
  children: string | ReactElement;
}) => {
  const router = useRouter();

  return (
    <Link
      href={href}
      className={classNames(
        "text-gray-600",
        router.pathname === href && "text-balck"
      )}
    >
      {children}
    </Link>
  );
};
